import type { SoundEffect } from "../../lib/sound.ts";

export interface DuelAudioState {
  matchId: string | null;
  live: boolean;
  previousMs: number;
  warnedAtThirty: boolean;
}

interface DuelAudioFrame {
  matchId: string | null;
  live: boolean;
  remainingMs: number;
  visible: boolean;
}

export const EMPTY_DUEL_AUDIO_STATE: DuelAudioState = {
  matchId: null,
  live: false,
  previousMs: 0,
  warnedAtThirty: false,
};

export function advanceDuelAudio(
  state: DuelAudioState,
  frame: DuelAudioFrame,
): { state: DuelAudioState; effects: SoundEffect[] } {
  const remainingMs = Math.max(0, frame.remainingMs);
  if (state.matchId !== frame.matchId || !frame.live || !state.live) {
    return {
      state: {
        matchId: frame.matchId,
        live: frame.live,
        previousMs: remainingMs,
        warnedAtThirty: false,
      },
      effects: [],
    };
  }

  const effects: SoundEffect[] = [];
  const crossedThirty = state.previousMs > 30_000 && remainingMs <= 30_000 && remainingMs > 0;
  const warnedAtThirty = state.warnedAtThirty || crossedThirty;
  if (crossedThirty && !state.warnedAtThirty && frame.visible) effects.push("warning-30");

  const previousSecond = Math.ceil(state.previousMs / 1000);
  const currentSecond = Math.ceil(remainingMs / 1000);
  const movedExactlyOneSecond = previousSecond === currentSecond + 1;
  if (
    frame.visible &&
    currentSecond >= 1 &&
    currentSecond <= 10 &&
    movedExactlyOneSecond
  ) {
    effects.push("tick");
  }

  return {
    state: {
      matchId: frame.matchId,
      live: true,
      previousMs: remainingMs,
      warnedAtThirty,
    },
    effects,
  };
}
